export default "/images/vendor/@coreui/icons/svg/flag/cif-al.svg?2bb9bab971ca241913f6ed2a711725c5";